@if(form) {
  <div class="" mat-dialog-content>
    <form [formGroup]="form">
      <div class="row justify-content-center mt-1 px-1 form-container">
        <h3 class="title">Add Bank Information</h3>
        <hr>

        <div class="col-12 col-md-6 border-right">
          <div class="q-header">Please fill your bank account details:</div>
          <div>
            <mat-form-field class="full-width">
              <mat-label>Account Type:</mat-label>
              <mat-select [formControlName]="'accountType'">
                @for(eachType of accountValues; track eachType.value) {
                  <mat-option [value]="eachType.value">{{eachType.label}}</mat-option>
                }
              </mat-select>
              <mat-error>Field required</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width">
              <mat-label>Ownership Type:</mat-label>
              <mat-select [formControlName]="'ownershipType'">
                @for(eachType of ownershipTypes; track eachType.value) {
                  <mat-option [value]="eachType.value">{{eachType.label}}</mat-option>
                }
              </mat-select>
              <mat-error>Field required</mat-error>
            </mat-form-field>
          </div>
          <div class="">
            <mat-form-field class="full-width">
              <mat-label>ABA / Routing Number:</mat-label>
              <input matInput [formControlName]="'routingNumber'">
              <mat-error>Expecting 8 to 9 digits</mat-error>
            </mat-form-field>
          </div>
    
          <div class="">
            <mat-form-field class="full-width">
              <mat-label>Account Number:</mat-label>
              <input matInput [formControlName]="'accountNumber'">
              <mat-error>Expecting 7 to 18 digits</mat-error>
            </mat-form-field>
          </div>

          @if(ownershipType === 'business') {
            <div class="">
              <mat-form-field class="full-width">
                <mat-label>Business Name:</mat-label>
                <input matInput [formControlName]="'businessName'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>
          }

          @if(ownershipType === 'personal') {
            <div>
              <mat-form-field class="full-width">
                <mat-label>First Name:</mat-label>
                <input matInput [formControlName]="'firstName'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-width">
                <mat-label>Last Name:</mat-label>
                <input matInput [formControlName]="'lastName'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>
          }
          
        </div>


        <div class="col-12 col-md-6">
          <div class="q-header">Please fill your bank account billing address:</div>

          <div formGroupName="billingAddress">
            <div class="">
              <mat-form-field class="full-width">
                <mat-label>Street address:</mat-label>
                <input matInput [formControlName]="'streetAddress'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>
            <div class="">
              <mat-form-field class="full-width">
                <mat-label>Address line 2:</mat-label>
                <input matInput [formControlName]="'extendedAddress'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>

            <div class="">
              <mat-form-field class="full-width">
                <mat-label>City:</mat-label>
                <input matInput [formControlName]="'locality'">
                <mat-error>Field required</mat-error>
              </mat-form-field>
            </div>
            <div class="">
              <mat-form-field class="full-width">
                <mat-label>State:</mat-label>
                <mat-select [formControlName]="'region'">
                  @for(eachState of states; track eachState.abbreviation) {
                    <mat-option [value]="eachState.abbreviation">{{eachState.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="">
              <mat-form-field class="full-width">
                <mat-label>Zip Code:</mat-label>
                <input matInput [formControlName]="'postalCode'">
                <mat-error>Values of type UsZipCode must have format DDDDD or DDDDD-DDDD</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        @if(form.valid) {
          <div class="col-12">
            <mat-checkbox [formControl]="authorizationControl">I autorize payment <span (click)="openAuthorizationDialog()">(see details)</span></mat-checkbox>
          </div>
        }
      </div>
    </form>
  </div>
    <mat-dialog-actions>
      <div>
        @if(isLoading()) {
          <div>Verifying account...</div>
        }
        @if(error()) {
          <div class="error">Error found: {{error()}}</div>
          <div>Please correct the errors and try again.</div>
        }
      </div>
      <div>
        <button mat-raised-button mat-dialog-close>Cancel</button>
        <button mat-raised-button (click)="registerAccount()" [disabled]="!authorizationControl.value || isLoading()">Register account</button>
      </div>
    </mat-dialog-actions>
}